No: No
Yes: Sí
RefuseGiftCard: ¿Rechazar la tarjeta de regalo?
useGiftCardTitle: Guía para usar una tarjeta de regalo
useGiftCardDesc: Después de recibir una tarjeta de regalo, puedes ver los comerciantes disponibles en la página de detalles de la tarjeta de regalo. Puedes elegir pagar con tu tarjeta de regalo directamente si haces un pedido con tu teléfono, o dar el número de teléfono al servidor en el mostrador para usar tu tarjeta de regalo.
ReceivedSuccess: Recibido con éxito
RefusedSuccess: Rechazado con éxito
requestFail: 'Error de red. Razón: {0}'
